module.exports = __webpack_public_path__ + "9e495f3bef52659ada71b137f6d66eea.svg";